import React, { useMemo, useState } from 'react';
import { Mail, MailOpen, MousePointer, ShoppingCart, Send, Eye, Edit, Trash2, Plus, Search, Filter, Download, AlertTriangle, CheckCircle2, Clock, Pause, Play, BarChart3, Users, DollarSign, FileText, Settings, X, ChevronRight, Activity, Zap, RefreshCw, LayoutList, MessageSquare, Globe, ArrowUpRight, ArrowDownRight, SplitSquareHorizontal, Target, Layers, CreditCard, History, TerminalSquare, Bell, Copy, Archive, Ban, Monitor, Smartphone } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
import { Pagination } from '../ui/Pagination';
import { Code } from 'lucide-react';
interface EmailCampaignsManagerProps {
  setDetailPanel: (panel: any) => void;
  success: (msg: string) => void;
}
// --- MOCK DATA ---
const mockCampaigns = [{
  id: 'EC-2026-001',
  name: 'Весенний прогноз 2026',
  type: 'promotional',
  advertiser: 'Astriqo',
  segment: 'Все активные пользователи',
  audienceSize: 45000,
  date: '15.03.2026 10:00',
  status: 'sent',
  sent: 45000,
  delivered: 44850,
  opens: 15338,
  openRate: '34.2%',
  clicks: 3363,
  ctr: '7.5%',
  conversions: 340,
  conversionRate: '10.1%',
  revenue: 450000,
  rpm: 10000,
  bounce: 120,
  bounceRate: '0.26%',
  unsubscribe: 45,
  unsubscribeRate: '0.1%',
  spam: 2,
  paymentStatus: 'paid',
  templateId: 'TPL-001',
  subject: 'Ваш весенний астрологический прогноз 🌸',
  previewText: 'Узнайте, что готовят звезды этой весной...',
  abTestId: null,
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'news@astriqo.com'
}, {
  id: 'EC-2026-002',
  name: 'Скидка 20% на Соляр',
  type: 'paid_placement',
  advertiser: 'Мария Звёздная',
  segment: 'Пользователи без заказа (30 дней)',
  audienceSize: 12500,
  date: '20.03.2026 12:00',
  status: 'scheduled',
  sent: 0,
  delivered: 0,
  opens: 0,
  openRate: '0%',
  clicks: 0,
  ctr: '0%',
  conversions: 0,
  conversionRate: '0%',
  revenue: 0,
  rpm: 0,
  bounce: 0,
  bounceRate: '0%',
  unsubscribe: 0,
  unsubscribeRate: '0%',
  spam: 0,
  paymentStatus: 'paid',
  templateId: 'TPL-005',
  subject: 'Скидка 20% на ваш Соляр 🎁',
  previewText: 'Только 48 часов! Подготовьтесь к новому году...',
  abTestId: 'AB-001',
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'promo@astriqo.com'
}, {
  id: 'EC-2026-003',
  name: 'Дайджест: Апрель',
  type: 'digest',
  advertiser: 'Astriqo',
  segment: 'Подписчики рассылки',
  audienceSize: 85000,
  date: '01.04.2026 09:00',
  status: 'draft',
  sent: 0,
  delivered: 0,
  opens: 0,
  openRate: '0%',
  clicks: 0,
  ctr: '0%',
  conversions: 0,
  conversionRate: '0%',
  revenue: 0,
  rpm: 0,
  bounce: 0,
  bounceRate: '0%',
  unsubscribe: 0,
  unsubscribeRate: '0%',
  spam: 0,
  paymentStatus: 'n/a',
  templateId: 'TPL-002',
  subject: 'Астро-дайджест: Апрель 2026 ♈',
  previewText: 'Главные астрологические события месяца...',
  abTestId: null,
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'digest@astriqo.com'
}, {
  id: 'EC-2026-004',
  name: 'Welcome Sequence #1',
  type: 'welcome_sequence',
  advertiser: 'Astriqo',
  segment: 'Новые регистрации',
  audienceSize: 150,
  date: 'Автоматически',
  status: 'sending',
  sent: 12450,
  delivered: 12400,
  opens: 8060,
  openRate: '65.0%',
  clicks: 2418,
  ctr: '19.5%',
  conversions: 450,
  conversionRate: '18.6%',
  revenue: 850000,
  rpm: 68273,
  bounce: 45,
  bounceRate: '0.36%',
  unsubscribe: 12,
  unsubscribeRate: '0.09%',
  spam: 0,
  paymentStatus: 'n/a',
  templateId: 'TPL-003',
  subject: 'Добро пожаловать в Astriqo! ✨',
  senderIdentity: 'welcome@astriqo.com'
}, {
  id: 'EC-2026-005',
  name: 'Брошенная корзина (Натал)',
  type: 'abandoned_cart',
  advertiser: 'Astriqo',
  segment: 'Брошенная корзина > 2ч',
  audienceSize: 45,
  date: 'Автоматически',
  status: 'sending',
  sent: 3200,
  delivered: 3180,
  opens: 1431,
  openRate: '45.0%',
  clicks: 429,
  ctr: '13.5%',
  conversions: 120,
  conversionRate: '27.9%',
  revenue: 348000,
  rpm: 108750,
  bounce: 15,
  bounceRate: '0.47%',
  unsubscribe: 8,
  unsubscribeRate: '0.25%',
  spam: 1,
  paymentStatus: 'n/a',
  templateId: 'TPL-004',
  subject: 'Вы забыли свой расчет натальной карты 🌙',
  previewText: 'Ваша карта ждет вас. Завершите оформление...',
  abTestId: null,
  automationId: 'AUTO-002',
  provider: 'Postmark',
  senderIdentity: 'support@astriqo.com'
}, {
  id: 'EC-2026-006',
  name: 'Реклама курса "Таро для начинающих"',
  type: 'external_ad',
  advertiser: 'Школа Таро',
  segment: 'Интерес: Таро',
  audienceSize: 18000,
  date: '10.03.2026 15:00',
  status: 'failed',
  sent: 5000,
  delivered: 4800,
  opens: 1200,
  openRate: '25.0%',
  clicks: 150,
  ctr: '3.1%',
  conversions: 12,
  conversionRate: '8.0%',
  revenue: 0,
  rpm: 0,
  bounce: 200,
  bounceRate: '4.0%',
  unsubscribe: 85,
  unsubscribeRate: '1.7%',
  spam: 15,
  paymentStatus: 'paid',
  templateId: 'TPL-006',
  subject: 'Освойте Таро за 30 дней 🎴',
  previewText: 'Новый курс от ведущих тарологов...',
  abTestId: null,
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'partners@astriqo.com',
  statusReason: 'provider_error'
}, {
  id: 'EC-2026-007',
  name: 'Напоминание об оплате подписки',
  type: 'renewal_reminder',
  advertiser: 'Astriqo',
  segment: 'Подписка истекает через 3 дня',
  audienceSize: 120,
  date: 'Автоматически',
  status: 'paused',
  sent: 8500,
  delivered: 8450,
  opens: 4225,
  openRate: '50.0%',
  clicks: 845,
  ctr: '10.0%',
  conversions: 650,
  conversionRate: '76.9%',
  revenue: 643500,
  rpm: 75705,
  bounce: 40,
  bounceRate: '0.47%',
  unsubscribe: 25,
  unsubscribeRate: '0.29%',
  spam: 0,
  paymentStatus: 'n/a',
  templateId: 'TPL-007',
  subject: 'Ваша подписка скоро истекает ⚡',
  previewText: 'Не потеряйте доступ к премиум функциям...',
  abTestId: null,
  automationId: 'AUTO-003',
  provider: 'Postmark',
  senderIdentity: 'billing@astriqo.com',
  statusReason: 'manually_paused'
}];
const mockTemplates = [{
  id: 'TPL-001',
  name: 'Стандартный промо',
  type: 'promo',
  subject: 'Специальное предложение для вас',
  previewText: 'Узнайте подробности внутри...',
  status: 'active',
  version: '1.2',
  updatedAt: '10.03.2026'
}, {
  id: 'TPL-002',
  name: 'Ежемесячный дайджест',
  type: 'newsletter',
  subject: 'Астро-дайджест',
  previewText: 'Главные события месяца',
  status: 'active',
  version: '3.0',
  updatedAt: '01.03.2026'
}, {
  id: 'TPL-003',
  name: 'Welcome Email',
  type: 'transactional',
  subject: 'Добро пожаловать!',
  previewText: 'С чего начать...',
  status: 'active',
  version: '2.1',
  updatedAt: '15.01.2026'
}];
const mockSegments = [{
  id: 'SEG-001',
  name: 'Все активные пользователи',
  size: 45000,
  type: 'dynamic',
  rules: 'last_login < 30 days',
  updatedAt: 'Сегодня, 10:00'
}, {
  id: 'SEG-002',
  name: 'VIP клиенты',
  size: 1250,
  type: 'dynamic',
  rules: 'ltv > 50000 RUB',
  updatedAt: 'Сегодня, 10:00'
}, {
  id: 'SEG-003',
  name: 'Интерес: Таро',
  size: 18000,
  type: 'static',
  rules: 'purchased_category = tarot OR viewed_category = tarot',
  updatedAt: 'Вчера, 15:30'
}];
const mockAutomations = [{
  id: 'AUTO-001',
  name: 'Welcome Sequence',
  trigger: 'User Registration',
  steps: 3,
  activeSubscribers: 450,
  completed: 12450,
  status: 'active'
}, {
  id: 'AUTO-002',
  name: 'Abandoned Cart',
  trigger: 'Cart Abandoned > 2h',
  steps: 2,
  activeSubscribers: 85,
  completed: 3200,
  status: 'active'
}, {
  id: 'AUTO-003',
  name: 'Subscription Renewal',
  trigger: 'Subscription expires in 3 days',
  steps: 1,
  activeSubscribers: 120,
  completed: 8500,
  status: 'paused'
}];
const mockAbTests = [{
  id: 'AB-001',
  name: 'Промо Соляр: Тема письма',
  campaignId: 'EC-2026-002',
  type: 'subject',
  variantA: 'Скидка 20% на ваш Соляр 🎁',
  variantB: 'Подготовьтесь к новому году: -20% на Соляр ✨',
  split: '50/50',
  status: 'scheduled',
  winner: null
}, {
  id: 'AB-002',
  name: 'Welcome: Кнопка CTA',
  campaignId: 'EC-2026-004',
  type: 'cta',
  variantA: 'Рассчитать карту',
  variantB: 'Узнать свою судьбу',
  split: '50/50',
  status: 'completed',
  winner: 'Variant B (+15% CTR)'
}];
// --- CONFIGS ---
const campaignTypeConfig: Record<string, {
  label: string;
  color: string;
}> = {
  promotional: {
    label: 'Промо',
    color: 'bg-amber-100 text-amber-700 border-amber-200'
  },
  paid_placement: {
    label: 'Платное',
    color: 'bg-purple-100 text-purple-700 border-purple-200'
  },
  digest: {
    label: 'Дайджест',
    color: 'bg-blue-100 text-blue-700 border-blue-200'
  },
  system: {
    label: 'Системное',
    color: 'bg-slate-100 text-slate-700 border-slate-200'
  },
  welcome_sequence: {
    label: 'Welcome',
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200'
  },
  abandoned_cart: {
    label: 'Брошенная корзина',
    color: 'bg-orange-100 text-orange-700 border-orange-200'
  },
  renewal_reminder: {
    label: 'Продление',
    color: 'bg-indigo-100 text-indigo-700 border-indigo-200'
  },
  external_ad: {
    label: 'Внешняя реклама',
    color: 'bg-rose-100 text-rose-700 border-rose-200'
  }
};
const campaignStatusConfig: Record<string, {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral' | 'pro';
}> = {
  draft: {
    label: 'Черновик',
    variant: 'neutral'
  },
  scheduled: {
    label: 'Запланировано',
    variant: 'warning'
  },
  sending: {
    label: 'Отправляется',
    variant: 'pro'
  },
  sent: {
    label: 'Отправлено',
    variant: 'success'
  },
  paused: {
    label: 'На паузе',
    variant: 'neutral'
  },
  failed: {
    label: 'Ошибка',
    variant: 'error'
  },
  archived: {
    label: 'В архиве',
    variant: 'neutral'
  }
};
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0
  }).format(amount);
};
export function EmailCampaignsManager({
  setDetailPanel,
  success
}: EmailCampaignsManagerProps) {
  const [campaigns, setCampaigns] = useState(mockCampaigns);
  const [activeTab, setActiveTab] = useState('campaigns');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    type: 'all'
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingCampaign, setEditingCampaign] = useState<any | null>(null);
  const [createForm, setCreateForm] = useState({
    name: '',
    type: 'promotional',
    subject: '',
    previewText: '',
    templateId: 'TPL-001',
    segment: 'Все активные пользователи (~45k)',
    sendDate: ''
  });
  const [selectedCampaigns, setSelectedCampaigns] = useState<Set<string>>(new Set());
  // Detail Modal State
  const [activeCampaignDetail, setActiveCampaignDetail] = useState<any | null>(null);
  const [detailTab, setDetailTab] = useState('overview');
  // Template Detail Modal
  const [activeTemplateDetail, setActiveTemplateDetail] = useState<any | null>(null);
  const [templateEditMode, setTemplateEditMode] = useState(false);
  const [templateForm, setTemplateForm] = useState({
    name: '',
    type: 'promo',
    subject: '',
    previewText: ''
  });
  // Segment Detail Modal
  const [activeSegmentDetail, setActiveSegmentDetail] = useState<any | null>(null);
  const [segmentEditMode, setSegmentEditMode] = useState(false);
  const [segmentForm, setSegmentForm] = useState({
    name: '',
    type: 'dynamic',
    rules: ''
  });
  // Automation Detail Modal
  const [activeAutomationDetail, setActiveAutomationDetail] = useState<any | null>(null);
  const [automationEditMode, setAutomationEditMode] = useState(false);
  // A/B Test Detail Modal
  const [activeAbTestDetail, setActiveAbTestDetail] = useState<any | null>(null);
  // --- FILTERING ---
  const filteredCampaigns = useMemo(() => {
    return campaigns.filter(c => {
      const matchesSearch = c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.id.toLowerCase().includes(searchQuery.toLowerCase()) || c.advertiser.toLowerCase().includes(searchQuery.toLowerCase());
      if (!matchesSearch) return false;
      if (filters.status !== 'all' && c.status !== filters.status) return false;
      if (filters.type !== 'all' && c.type !== filters.type) return false;
      return true;
    });
  }, [campaigns, searchQuery, filters]);
  const totalPages = Math.ceil(filteredCampaigns.length / itemsPerPage);
  const currentCampaigns = filteredCampaigns.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const toggleSelectAll = () => {
    if (selectedCampaigns.size === currentCampaigns.length) {
      setSelectedCampaigns(new Set());
    } else {
      setSelectedCampaigns(new Set(currentCampaigns.map(c => c.id)));
    }
  };
  const toggleSelect = (id: string) => {
    const newSet = new Set(selectedCampaigns);
    if (newSet.has(id)) newSet.delete(id);else newSet.add(id);
    setSelectedCampaigns(newSet);
  };
  // --- ACTIONS ---
  const handleAction = (action: string, id?: string) => {
    const targetId = id || (selectedCampaigns.size === 1 ? Array.from(selectedCampaigns)[0] : null);
    const count = id ? 1 : selectedCampaigns.size;
    switch (action) {
      case 'pause':
        success(`Приостановлено кампаний: ${count}`);
        break;
      case 'resume':
        success(`Возобновлено кампаний: ${count}`);
        break;
      case 'archive':
        success(`Архивировано кампаний: ${count}`);
        break;
      case 'duplicate':
        success(`Кампания скопирована`);
        break;
      case 'export':
        success(`Экспорт данных начат`);
        break;
    }
    if (!id) setSelectedCampaigns(new Set());
  };
  const openDetail = (campaign: any) => {
    setActiveCampaignDetail(campaign);
    setDetailTab('overview');
  };
  // --- RENDERERS ---
  const renderKpiCard = (label: string, value: string | number, icon: React.ReactNode, bgClass: string, textClass: string, onClickFilter?: Partial<typeof filters>) => <Card padding="sm" hoverable className="rounded-xl shadow-none border-slate-200 p-4 flex flex-col justify-between h-24 cursor-pointer group transition-all hover:border-indigo-300 hover:shadow-md" onClick={() => {
    if (onClickFilter) {
      setFilters({
        ...filters,
        ...onClickFilter
      });
      setCurrentPage(1);
      setActiveTab('campaigns');
    }
  }} data-id="element-10824">
      <div className="flex justify-between items-start" data-id="element-10825">
        <div className={`w-8 h-8 rounded-lg ${bgClass} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-10826">
          {icon}
        </div>
      </div>
      <div data-id="element-10827">
        <div className="text-xs text-slate-500 font-medium mb-0.5" data-id="element-10828">{label}</div>
        <div className={`text-xl font-bold ${textClass}`} data-id="element-10829">{value}</div>
      </div>
    </Card>;
  const renderTopMetrics = () => <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6" data-id="element-10830">
      {renderKpiCard('Всего кампаний', mockCampaigns.length, <Mail className="w-4 h-4 text-indigo-600" data-id="element-10831" />, 'bg-indigo-50', 'text-slate-900', {
      status: 'all'
    })}
      {renderKpiCard('Ср. Open Rate', '38.4%', <MailOpen className="w-4 h-4 text-blue-600" data-id="element-10832" />, 'bg-blue-50', 'text-blue-700')}
      {renderKpiCard('Ср. CTR', '8.2%', <MousePointer className="w-4 h-4 text-purple-600" data-id="element-10833" />, 'bg-purple-50', 'text-purple-700')}
      {renderKpiCard('Конверсии', '1,462', <ShoppingCart className="w-4 h-4 text-amber-600" data-id="element-10834" />, 'bg-amber-50', 'text-amber-700')}
      {renderKpiCard('Доход', '2.2M ₽', <DollarSign className="w-4 h-4 text-emerald-600" data-id="element-10835" />, 'bg-emerald-50', 'text-emerald-700')}

      {renderKpiCard('Отправлено', '71K', <Send className="w-4 h-4 text-slate-600" data-id="element-10836" />, 'bg-slate-100', 'text-slate-900')}
      {renderKpiCard('Доставлено', '99.2%', <CheckCircle2 className="w-4 h-4 text-emerald-600" data-id="element-10837" />, 'bg-emerald-50', 'text-emerald-700')}
      {renderKpiCard('Bounce Rate', '0.8%', <ArrowUpRight className="w-4 h-4 text-orange-600" data-id="element-10838" />, 'bg-orange-50', 'text-orange-700')}
      {renderKpiCard('Unsubscribe', '0.2%', <ArrowDownRight className="w-4 h-4 text-rose-600" data-id="element-10839" />, 'bg-rose-50', 'text-rose-700')}
      {renderKpiCard('В процессе', '2', <Activity className="w-4 h-4 text-indigo-600" data-id="element-10840" />, 'bg-indigo-50', 'text-indigo-700', {
      status: 'sending'
    })}
    </div>;
  const renderCampaignsTable = () => <div className="space-y-4" data-id="element-10841">
      {/* Filter Bar */}
      <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-10842">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-10843">
          <div className="flex items-center gap-3 w-full sm:w-auto flex-1" data-id="element-10844">
            <div className="relative flex-1 max-w-md" data-id="element-10845">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-10846" />
              <input type="text" placeholder="Поиск по ID, названию, рекламодателю..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-10847" />
            </div>
            <Button variant={showFilters ? 'primary' : 'outline'} size="sm" icon={<Filter className="w-4 h-4" data-id="element-10849" />} onClick={() => setShowFilters(!showFilters)} data-id="element-10848">
              Фильтры
            </Button>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-10850">
            <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-10852" />} onClick={() => handleAction('export')} data-id="element-10851">
              Экспорт
            </Button>
            <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-10854" />} onClick={() => {
            setEditingCampaign(null);
            setCreateForm({
              name: '',
              type: 'promotional',
              subject: '',
              previewText: '',
              templateId: 'TPL-001',
              segment: 'Все активные пользователи (~45k)',
              sendDate: ''
            });
            setShowCreateModal(true);
          }} data-id="element-10853">
              Создать кампанию
            </Button>
          </div>
        </div>

        {showFilters && <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-4 gap-4 animate-in fade-in slide-in-from-top-2" data-id="element-10855">
            <div data-id="element-10856">
              <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-10857">
                Статус
              </label>
              <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.status} onChange={e => setFilters({
            ...filters,
            status: e.target.value
          })} data-id="element-10858">
                <option value="all" data-id="element-10859">Все статусы</option>
                <option value="draft" data-id="element-10860">Черновик</option>
                <option value="scheduled" data-id="element-10861">Запланировано</option>
                <option value="sending" data-id="element-10862">Отправляется</option>
                <option value="sent" data-id="element-10863">Отправлено</option>
                <option value="paused" data-id="element-10864">На паузе</option>
                <option value="failed" data-id="element-10865">Ошибка</option>
              </select>
            </div>
            <div data-id="element-10866">
              <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-10867">
                Тип
              </label>
              <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.type} onChange={e => setFilters({
            ...filters,
            type: e.target.value
          })} data-id="element-10868">
                <option value="all" data-id="element-10869">Все типы</option>
                <option value="promotional" data-id="element-10870">Промо</option>
                <option value="paid_placement" data-id="element-10871">Платное</option>
                <option value="digest" data-id="element-10872">Дайджест</option>
                <option value="welcome_sequence" data-id="element-10873">Welcome</option>
                <option value="abandoned_cart" data-id="element-10874">Брошенная корзина</option>
              </select>
            </div>
          </div>}
      </Card>

      {/* Mass Actions */}
      {selectedCampaigns.size > 0 && <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-3 flex items-center justify-between animate-in fade-in" data-id="element-10875">
          <div className="flex items-center gap-3" data-id="element-10876">
            <Badge variant="pro" data-id="element-10877">{selectedCampaigns.size} выбрано</Badge>
            <span className="text-sm text-indigo-800 font-medium" data-id="element-10878">
              Действия:
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-10879">
            <Button variant="outline" size="sm" className="bg-white" icon={<Pause className="w-4 h-4" data-id="element-10881" />} onClick={() => handleAction('pause')} data-id="element-10880">
              Пауза
            </Button>
            <Button variant="outline" size="sm" className="bg-white" icon={<Play className="w-4 h-4" data-id="element-10883" />} onClick={() => handleAction('resume')} data-id="element-10882">
              Возобновить
            </Button>
            <Button variant="outline" size="sm" className="bg-white text-rose-600 hover:text-rose-700 hover:bg-rose-50" icon={<Archive className="w-4 h-4" data-id="element-10885" />} onClick={() => handleAction('archive')} data-id="element-10884">
              В архив
            </Button>
          </div>
        </div>}

      {/* Table */}
      <Card padding="none" className="rounded-xl shadow-sm border-slate-200 overflow-hidden" data-id="element-10886">
        <div className="overflow-x-auto" data-id="element-10887">
          <table className="w-full text-left whitespace-nowrap" data-id="element-10888">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-10889">
              <tr data-id="element-10890">
                <th className="px-4 py-3 w-10 text-center" data-id="element-10891">
                  <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500" checked={selectedCampaigns.size === currentCampaigns.length && currentCampaigns.length > 0} onChange={toggleSelectAll} data-id="element-10892" />
                </th>
                <th className="px-4 py-3 font-medium" data-id="element-10893">Кампания</th>
                <th className="px-4 py-3 font-medium" data-id="element-10894">Статус</th>
                <th className="px-4 py-3 font-medium" data-id="element-10895">Аудитория</th>
                <th className="px-4 py-3 font-medium" data-id="element-10896">Отправлено</th>
                <th className="px-4 py-3 font-medium" data-id="element-10897">Open Rate</th>
                <th className="px-4 py-3 font-medium" data-id="element-10898">CTR</th>
                <th className="px-4 py-3 font-medium" data-id="element-10899">Конверсии</th>
                <th className="px-4 py-3 font-medium" data-id="element-10900">Доход</th>
                <th className="px-4 py-3 text-right font-medium" data-id="element-10901">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-10902">
              {currentCampaigns.map(c => {
              const typeInfo = campaignTypeConfig[c.type];
              const statusInfo = campaignStatusConfig[c.status];
              return <tr key={c.id} className="hover:bg-slate-50 transition-colors group" data-id="element-10903">
                    <td className="px-4 py-3 text-center" data-id="element-10904">
                      <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500" checked={selectedCampaigns.has(c.id)} onChange={() => toggleSelect(c.id)} data-id="element-10905" />
                    </td>
                    <td className="px-4 py-3" data-id="element-10906">
                      <div className="flex flex-col gap-1" data-id="element-10907">
                        <div className="text-sm font-bold text-slate-900 cursor-pointer hover:text-indigo-600 transition-colors" onClick={() => openDetail(c)} data-id="element-10908">
                          {c.name}
                        </div>
                        <div className="flex items-center gap-2" data-id="element-10909">
                          <span className="text-[10px] text-slate-500 font-mono" data-id="element-10910">
                            {c.id}
                          </span>
                          <span className={`text-[10px] px-1.5 py-0.5 rounded border ${typeInfo?.color || 'bg-slate-100 text-slate-600'}`} data-id="element-10911">
                            {typeInfo?.label || c.type}
                          </span>
                          {c.abTestId && <span className="text-[10px] px-1.5 py-0.5 rounded border bg-amber-50 text-amber-600 border-amber-200 flex items-center gap-1" data-id="element-10912">
                              <SplitSquareHorizontal className="w-3 h-3" data-id="element-10913" /> A/B
                            </span>}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10914">
                      <Badge variant={statusInfo?.variant || 'neutral'} size="sm" className="cursor-pointer" onClick={() => openDetail(c)} data-id="element-10915">
                        {statusInfo?.label || c.status}
                      </Badge>
                      <div className="text-[10px] text-slate-400 mt-1" data-id="element-10916">
                        {c.date}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10917">
                      <div className="text-sm text-slate-700 font-medium cursor-pointer hover:text-indigo-600" onClick={() => setActiveTab('audiences')} data-id="element-10918">
                        {c.segment}
                      </div>
                      <div className="text-[10px] text-slate-500 flex items-center gap-1 mt-0.5" data-id="element-10919">
                        <Users className="w-3 h-3" data-id="element-10920" />{' '}
                        {c.audienceSize.toLocaleString('ru-RU')}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10921">
                      <div className="text-sm font-medium text-slate-900" data-id="element-10922">
                        {c.sent.toLocaleString('ru-RU')}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10923">
                        Дост: {c.delivered.toLocaleString('ru-RU')}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10924">
                      <div className="text-sm font-bold text-blue-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10925">
                        {c.openRate}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10926">
                        {c.opens.toLocaleString('ru-RU')} откр.
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10927">
                      <div className="text-sm font-bold text-purple-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10928">
                        {c.ctr}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10929">
                        {c.clicks.toLocaleString('ru-RU')} клик.
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10930">
                      <div className="text-sm font-bold text-amber-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10931">
                        {c.conversions}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10932">
                        CR: {c.conversionRate}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10933">
                      <div className="text-sm font-bold text-emerald-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10934">
                        {formatCurrency(c.revenue)}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10935">
                        RPM: {formatCurrency(c.rpm)}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-10936">
                      <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-10937">
                        <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-indigo-600" icon={<Eye className="w-4 h-4" data-id="element-10939" />} onClick={() => openDetail(c)} title="Просмотр" data-id="element-10938" />
                        <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-blue-600" icon={<Edit className="w-4 h-4" data-id="element-10941" />} onClick={() => {
                      setEditingCampaign(c);
                      setCreateForm({
                        name: c.name,
                        type: c.type,
                        subject: c.subject,
                        previewText: c.previewText,
                        templateId: c.templateId,
                        segment: c.segment,
                        sendDate: c.date !== 'Автоматически' ? c.date : ''
                      });
                      setShowCreateModal(true);
                    }} title="Редактировать" data-id="element-10940" />
                        <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-amber-600" icon={<Copy className="w-4 h-4" data-id="element-10943" />} onClick={() => handleAction('duplicate', c.id)} title="Дублировать" data-id="element-10942" />
                        {c.status === 'sending' || c.status === 'scheduled' ? <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-orange-600" icon={<Pause className="w-4 h-4" data-id="element-10945" />} onClick={() => handleAction('pause', c.id)} title="Пауза" data-id="element-10944" /> : c.status === 'paused' ? <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-emerald-600" icon={<Play className="w-4 h-4" data-id="element-10947" />} onClick={() => handleAction('resume', c.id)} title="Возобновить" data-id="element-10946" /> : null}
                      </div>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && <div className="p-4 border-t border-slate-100 bg-slate-50 flex justify-center" data-id="element-10948">
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} data-id="element-10949" />
          </div>}
      </Card>
    </div>;
  const renderTemplates = () => <div className="space-y-4" data-id="element-10950">
      <div className="flex justify-between items-center" data-id="element-10951">
        <div data-id="element-10952">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10953">Шаблоны писем</h3>
          <p className="text-sm text-slate-500" data-id="element-10954">
            Управление HTML-шаблонами для рассылок
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10956" />} onClick={() => {
        setTemplateEditMode(true);
        setTemplateForm({
          name: '',
          type: 'promo',
          subject: '',
          previewText: ''
        });
        setActiveTemplateDetail({
          id: 'NEW',
          name: 'Новый шаблон',
          status: 'draft'
        });
      }} data-id="element-10955">
          Создать шаблон
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10957">
        {mockTemplates.map(t => <Card key={t.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => {
        setTemplateEditMode(false);
        setActiveTemplateDetail(t);
      }} data-id="element-10958">
            <div className="flex justify-between items-start mb-4" data-id="element-10959">
              <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600" data-id="element-10960">
                <LayoutList className="w-5 h-5" data-id="element-10961" />
              </div>
              <Badge variant={t.status === 'active' ? 'success' : 'neutral'} data-id="element-10962">
                {t.status}
              </Badge>
            </div>
            <h4 className="font-bold text-slate-900 mb-1" data-id="element-10963">{t.name}</h4>
            <p className="text-xs text-slate-500 mb-4 line-clamp-2" data-id="element-10964">
              {t.subject}
            </p>
            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-10965">
              <span className="font-mono" data-id="element-10966">{t.id}</span>
              <span data-id="element-10967">
                v{t.version} • {t.updatedAt}
              </span>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderAudiences = () => <div className="space-y-4" data-id="element-10968">
      <div className="flex justify-between items-center" data-id="element-10969">
        <div data-id="element-10970">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10971">
            Сегменты аудитории
          </h3>
          <p className="text-sm text-slate-500" data-id="element-10972">
            Динамические и статические списки получателей
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10974" />} onClick={() => {
        setSegmentEditMode(true);
        setSegmentForm({
          name: '',
          type: 'dynamic',
          rules: ''
        });
        setActiveSegmentDetail({
          id: 'NEW',
          name: 'Новый сегмент',
          size: 0,
          type: 'dynamic'
        });
      }} data-id="element-10973">
          Создать сегмент
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10975">
        {mockSegments.map(s => <Card key={s.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => {
        setSegmentEditMode(false);
        setActiveSegmentDetail(s);
      }} data-id="element-10976">
            <div className="flex justify-between items-start mb-4" data-id="element-10977">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 shrink-0" data-id="element-10978">
                <Users className="w-6 h-6" data-id="element-10979" />
              </div>
              <Badge variant={s.type === 'dynamic' ? 'pro' : 'neutral'} data-id="element-10980">
                {s.type}
              </Badge>
            </div>
            <h4 className="font-bold text-slate-900 mb-1" data-id="element-10981">{s.name}</h4>
            <div className="text-2xl font-bold text-slate-700 mb-4" data-id="element-10982">
              {s.size.toLocaleString('ru-RU')}{' '}
              <span className="text-xs font-normal text-slate-500" data-id="element-10983">
                пользователей
              </span>
            </div>
            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-10984">
              <span className="truncate max-w-[150px]" title={s.rules} data-id="element-10985">
                {s.rules}
              </span>
              <span data-id="element-10986">{s.updatedAt}</span>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderAutomations = () => <div className="space-y-4" data-id="element-10987">
      <div className="flex justify-between items-center" data-id="element-10988">
        <div data-id="element-10989">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10990">Автоматизации</h3>
          <p className="text-sm text-slate-500" data-id="element-10991">
            Триггерные цепочки писем (Flows)
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10993" />} onClick={() => {
        setAutomationEditMode(true);
        setActiveAutomationDetail({
          id: 'NEW',
          name: 'Новая автоматизация',
          status: 'draft',
          steps: 0,
          activeSubscribers: 0,
          completed: 0
        });
      }} data-id="element-10992">
          Создать Flow
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10994">
        {mockAutomations.map(a => <Card key={a.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => {
        setAutomationEditMode(false);
        setActiveAutomationDetail(a);
      }} data-id="element-10995">
            <div className="flex justify-between items-start mb-4" data-id="element-10996">
              <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600 shrink-0" data-id="element-10997">
                <Zap className="w-5 h-5" data-id="element-10998" />
              </div>
              <Badge variant={a.status === 'active' ? 'success' : 'neutral'} data-id="element-10999">
                {a.status}
              </Badge>
            </div>
            <h4 className="font-bold text-slate-900 mb-1" data-id="element-11000">{a.name}</h4>
            <p className="text-xs text-slate-500 mb-4 flex items-center gap-1" data-id="element-11001">
              <Target className="w-3 h-3" data-id="element-11002" /> {a.trigger}
            </p>
            <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-11003">
              <div className="bg-slate-50 p-2 rounded text-center" data-id="element-11004">
                <div className="text-xs font-bold text-slate-900" data-id="element-11005">
                  {a.steps}
                </div>
                <div className="text-[9px] text-slate-500" data-id="element-11006">Шагов</div>
              </div>
              <div className="bg-slate-50 p-2 rounded text-center" data-id="element-11007">
                <div className="text-xs font-bold text-slate-900" data-id="element-11008">
                  {a.activeSubscribers}
                </div>
                <div className="text-[9px] text-slate-500" data-id="element-11009">Активны</div>
              </div>
              <div className="bg-slate-50 p-2 rounded text-center" data-id="element-11010">
                <div className="text-xs font-bold text-slate-900" data-id="element-11011">
                  {a.completed >= 1000 ? `${(a.completed / 1000).toFixed(1)}k` : a.completed}
                </div>
                <div className="text-[9px] text-slate-500" data-id="element-11012">Завершили</div>
              </div>
            </div>
            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-11013">
              <span className="font-mono" data-id="element-11014">{a.id}</span>
              <span className="text-indigo-600 font-medium hover:underline" data-id="element-11015">
                Редактировать Flow
              </span>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderAbTests = () => <div className="space-y-4" data-id="element-11016">
      <div className="flex justify-between items-center" data-id="element-11017">
        <div data-id="element-11018">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-11019">A/B Тесты</h3>
          <p className="text-sm text-slate-500" data-id="element-11020">Сплит-тестирование кампаний</p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-11022" />} onClick={() => {
        setActiveAbTestDetail({
          id: 'NEW',
          name: 'Новый A/B тест',
          status: 'draft',
          split: '50/50'
        });
      }} data-id="element-11021">
          Новый тест
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-11023">
        {mockAbTests.map(t => <Card key={t.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => setActiveAbTestDetail(t)} data-id="element-11024">
            <div className="flex justify-between items-start mb-4" data-id="element-11025">
              <div className="flex items-center gap-3" data-id="element-11026">
                <div className="w-10 h-10 rounded-lg bg-rose-50 flex items-center justify-center text-rose-600" data-id="element-11027">
                  <SplitSquareHorizontal className="w-5 h-5" data-id="element-11028" />
                </div>
                <div data-id="element-11029">
                  <h4 className="font-bold text-slate-900" data-id="element-11030">{t.name}</h4>
                  <p className="text-xs text-slate-500" data-id="element-11031">
                    Кампания: {t.campaignId}
                  </p>
                </div>
              </div>
              <Badge variant={t.status === 'completed' ? 'success' : 'warning'} data-id="element-11032">
                {t.status}
              </Badge>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-11033">
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-11034">
                <div className="text-[10px] font-bold text-slate-500 uppercase mb-1" data-id="element-11035">
                  Вариант A ({t.split.split('/')[0]}%)
                </div>
                <div className="text-sm text-slate-700" data-id="element-11036">{t.variantA}</div>
              </div>
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-11037">
                <div className="text-[10px] font-bold text-slate-500 uppercase mb-1" data-id="element-11038">
                  Вариант B ({t.split.split('/')[1]}%)
                </div>
                <div className="text-sm text-slate-700" data-id="element-11039">{t.variantB}</div>
              </div>
            </div>

            {t.winner && <div className="bg-emerald-50 text-emerald-700 p-2 rounded-lg text-xs font-medium flex items-center gap-2 mb-4" data-id="element-11040">
                <CheckCircle2 className="w-4 h-4" data-id="element-11041" /> Победитель: {t.winner}
              </div>}

            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-11042">
              <span className="font-mono" data-id="element-11043">{t.id}</span>
              <span className="uppercase" data-id="element-11044">{t.type} test</span>
            </div>
          </Card>)}
      </div>
    </div>;
  // --- DETAIL MODAL ---
  const renderCampaignDetailModal = () => {
    if (!activeCampaignDetail) return null;
    const c = activeCampaignDetail;
    const typeInfo = campaignTypeConfig[c.type];
    const statusInfo = campaignStatusConfig[c.status];
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-11045">
        <Card className="w-full max-w-6xl h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-11046">
          {/* Header */}
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-11047">
            <div className="flex items-start gap-4" data-id="element-11048">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0" data-id="element-11049">
                <Mail className="w-6 h-6" data-id="element-11050" />
              </div>
              <div data-id="element-11051">
                <div className="flex items-center gap-3 mb-1" data-id="element-11052">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-11053">{c.name}</h2>
                  <Badge variant={statusInfo?.variant || 'neutral'} data-id="element-11054">
                    {statusInfo?.label || c.status}
                  </Badge>
                  {c.statusReason && <span className="text-xs text-rose-600 flex items-center gap-1 bg-rose-50 px-2 py-0.5 rounded-full" data-id="element-11055">
                      <AlertTriangle className="w-3 h-3" data-id="element-11056" /> {c.statusReason}
                    </span>}
                </div>
                <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-11057">
                  <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-11058">
                    {c.id}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-11059">
                    <Clock className="w-3.5 h-3.5" data-id="element-11060" /> {c.date}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-11061">
                    <Users className="w-3.5 h-3.5" data-id="element-11062" /> {c.segment}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-11063">
              <Button variant="outline" size="sm" icon={<Eye className="w-4 h-4" data-id="element-11065" />} onClick={() => success('Превью открыто')} data-id="element-11064">
                Preview
              </Button>
              <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-11067" />} onClick={() => {
              setEditingCampaign(c);
              setCreateForm({
                name: c.name,
                type: c.type,
                subject: c.subject,
                previewText: c.previewText,
                templateId: c.templateId,
                segment: c.segment,
                sendDate: c.date !== 'Автоматически' ? c.date : ''
              });
              setShowCreateModal(true);
            }} data-id="element-11066">
                Edit
              </Button>
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-11069" />} onClick={() => setActiveCampaignDetail(null)} data-id="element-11068" />
            </div>
          </div>

          {/* Tabs */}
          <div className="px-6 border-b border-slate-200 bg-slate-50 shrink-0" data-id="element-11070">
            <Tabs activeTab={detailTab} onChange={setDetailTab} tabs={[{
            id: 'overview',
            label: 'Основное'
          }, {
            id: 'template',
            label: 'Шаблон письма'
          }, {
            id: 'audience',
            label: 'Аудитория'
          }, {
            id: 'analytics',
            label: 'Аналитика'
          }, {
            id: 'conversions',
            label: 'Конверсии'
          }, {
            id: 'payment',
            label: 'Оплата'
          }, {
            id: 'timeline',
            label: 'Таймлайн'
          }, {
            id: 'logs',
            label: 'Логи'
          }, {
            id: 'abtest',
            label: 'A/B Тест'
          }]} data-id="element-11071" />
          </div>

          {/* Content Area */}
          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-11072">
            {detailTab === 'overview' && <div className="space-y-6" data-id="element-11073">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11074">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11075">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-11076">
                      Информация
                    </h3>
                    <div className="space-y-3" data-id="element-11077">
                      <div className="flex justify-between" data-id="element-11078">
                        <span className="text-xs text-slate-500" data-id="element-11079">ID</span>
                        <span className="text-xs font-mono text-slate-900" data-id="element-11080">
                          {c.id}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11081">
                        <span className="text-xs text-slate-500" data-id="element-11082">Тип</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11083">
                          {typeInfo?.label}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11084">
                        <span className="text-xs text-slate-500" data-id="element-11085">Владелец</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11086">
                          {c.advertiser}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11087">
                        <span className="text-xs text-slate-500" data-id="element-11088">
                          Провайдер
                        </span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11089">
                          {c.provider}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11090">
                        <span className="text-xs text-slate-500" data-id="element-11091">
                          Отправитель
                        </span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11092">
                          {c.senderIdentity}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11093">
                        <span className="text-xs text-slate-500" data-id="element-11094">Шаблон</span>
                        <span className="text-xs font-medium text-indigo-600 cursor-pointer hover:underline" data-id="element-11095">
                          {c.templateId}
                        </span>
                      </div>
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 md:col-span-2" data-id="element-11096">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-11097">
                      Контент
                    </h3>
                    <div className="space-y-4" data-id="element-11098">
                      <div data-id="element-11099">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-11100">
                          Тема письма (Subject)
                        </div>
                        <div className="text-sm font-medium text-slate-900 bg-slate-100 p-2 rounded" data-id="element-11101">
                          {c.subject}
                        </div>
                      </div>
                      <div data-id="element-11102">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-11103">
                          Превью (Preheader)
                        </div>
                        <div className="text-sm text-slate-700 bg-slate-100 p-2 rounded" data-id="element-11104">
                          {c.previewText}
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>

                <h3 className="text-lg font-bold text-slate-900 mt-8 mb-4" data-id="element-11105">
                  Быстрая статистика
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-11106">
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-11107">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11108">
                      Отправлено
                    </div>
                    <div className="text-2xl font-bold text-slate-900" data-id="element-11109">
                      {c.sent.toLocaleString('ru-RU')}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-11110">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11111">Open Rate</div>
                    <div className="text-2xl font-bold text-blue-600" data-id="element-11112">
                      {c.openRate}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-11113">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11114">CTR</div>
                    <div className="text-2xl font-bold text-purple-600" data-id="element-11115">
                      {c.ctr}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-11116">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11117">Доход</div>
                    <div className="text-2xl font-bold text-emerald-600" data-id="element-11118">
                      {formatCurrency(c.revenue)}
                    </div>
                  </div>
                </div>
              </div>}

            {detailTab === 'analytics' && <div className="space-y-6" data-id="element-11119">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-11120">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11121">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11122">
                      Доставлено
                    </div>
                    <div className="text-xl font-bold text-slate-900" data-id="element-11123">
                      {c.delivered.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-emerald-600 mt-1" data-id="element-11124">
                      {(c.delivered / c.sent * 100 || 0).toFixed(1)}% Delivery
                      Rate
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11125">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11126">
                      Открытия (Unique)
                    </div>
                    <div className="text-xl font-bold text-blue-600" data-id="element-11127">
                      {c.opens.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1" data-id="element-11128">
                      Open Rate: {c.openRate}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11129">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11130">
                      Клики (Unique)
                    </div>
                    <div className="text-xl font-bold text-purple-600" data-id="element-11131">
                      {c.clicks.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1" data-id="element-11132">
                      CTR: {c.ctr}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11133">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11134">Конверсии</div>
                    <div className="text-xl font-bold text-amber-600" data-id="element-11135">
                      {c.conversions.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1" data-id="element-11136">
                      CR: {c.conversionRate}
                    </div>
                  </Card>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-11137">
                  <Card padding="md" className="shadow-none border-slate-200 bg-orange-50/50" data-id="element-11138">
                    <div className="flex items-center gap-2 mb-2" data-id="element-11139">
                      <ArrowUpRight className="w-4 h-4 text-orange-500" data-id="element-11140" />
                      <div className="text-sm font-bold text-slate-900" data-id="element-11141">
                        Bounces
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-orange-600" data-id="element-11142">
                      {c.bounce}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-11143">
                      Rate: {c.bounceRate}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 bg-rose-50/50" data-id="element-11144">
                    <div className="flex items-center gap-2 mb-2" data-id="element-11145">
                      <ArrowDownRight className="w-4 h-4 text-rose-500" data-id="element-11146" />
                      <div className="text-sm font-bold text-slate-900" data-id="element-11147">
                        Unsubscribes
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-rose-600" data-id="element-11148">
                      {c.unsubscribe}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-11149">
                      Rate: {c.unsubscribeRate}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 bg-red-50/50" data-id="element-11150">
                    <div className="flex items-center gap-2 mb-2" data-id="element-11151">
                      <AlertTriangle className="w-4 h-4 text-red-500" data-id="element-11152" />
                      <div className="text-sm font-bold text-slate-900" data-id="element-11153">
                        Spam Complaints
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-red-600" data-id="element-11154">
                      {c.spam}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-11155">
                      Rate: {(c.spam / c.sent * 100 || 0).toFixed(3)}%
                    </div>
                  </Card>
                </div>

                <Card padding="md" className="shadow-none border-slate-200" data-id="element-11156">
                  <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-11157">
                    Финансовая эффективность
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-11158">
                    <div data-id="element-11159">
                      <div className="text-xs text-slate-500 mb-1" data-id="element-11160">
                        Общий доход (Attributed)
                      </div>
                      <div className="text-2xl font-bold text-emerald-600" data-id="element-11161">
                        {formatCurrency(c.revenue)}
                      </div>
                    </div>
                    <div data-id="element-11162">
                      <div className="text-xs text-slate-500 mb-1" data-id="element-11163">
                        RPM (Доход на 1000 писем)
                      </div>
                      <div className="text-2xl font-bold text-emerald-600" data-id="element-11164">
                        {formatCurrency(c.rpm)}
                      </div>
                    </div>
                  </div>
                </Card>
              </div>}

            {detailTab === 'audience' && <div className="space-y-6" data-id="element-11165">
                <Card padding="md" className="shadow-none border-slate-200" data-id="element-11166">
                  <div className="flex justify-between items-start mb-6" data-id="element-11167">
                    <div data-id="element-11168">
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-11169">
                        Сегмент: {c.segment}
                      </h3>
                      <p className="text-sm text-slate-500" data-id="element-11170">
                        Размер аудитории:{' '}
                        {c.audienceSize.toLocaleString('ru-RU')} пользователей
                      </p>
                    </div>
                    <Button variant="outline" size="sm" icon={<Users className="w-4 h-4" data-id="element-11172" />} onClick={() => success('Открыт сегмент')} data-id="element-11171">
                      Посмотреть сегмент
                    </Button>
                  </div>

                  <div className="bg-slate-100 rounded-lg p-4 mb-6" data-id="element-11173">
                    <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-11174">
                      Правила сегментации
                    </h4>
                    <code className="text-sm text-slate-800 block whitespace-pre-wrap" data-id="element-11175">
                      {`SELECT * FROM users
WHERE last_login < NOW() - INTERVAL '30 days'
AND has_orders = false
AND is_subscribed_to_emails = true`}
                    </code>
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-11176">
                    <div className="border border-slate-200 rounded-lg p-4" data-id="element-11177">
                      <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-11178">
                        Исключения (Exclusions)
                      </h4>
                      <ul className="text-sm text-slate-600 space-y-1 list-disc list-inside pl-4" data-id="element-11179">
                        <li data-id="element-11180">Пользователи с активной подпиской Pro</li>
                        <li data-id="element-11181">
                          Пользователи, совершившие покупку за последние 7 дней
                        </li>
                      </ul>
                    </div>
                    <div className="border border-slate-200 rounded-lg p-4" data-id="element-11182">
                      <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-11183">
                        Suppression Lists
                      </h4>
                      <ul className="text-sm text-slate-600 space-y-1 list-disc list-inside pl-4" data-id="element-11184">
                        <li data-id="element-11185">Global Bounces</li>
                        <li data-id="element-11186">Global Unsubscribes</li>
                        <li data-id="element-11187">Spam Complainers</li>
                      </ul>
                    </div>
                  </div>
                </Card>
              </div>}

            {detailTab === 'template' && <div className="space-y-6 h-full flex flex-col" data-id="element-11188">
                <div className="flex justify-between items-center" data-id="element-11189">
                  <div data-id="element-11190">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-11191">
                      Шаблон: {c.templateId}
                    </h3>
                    <p className="text-sm text-slate-500" data-id="element-11192">
                      Превью письма для десктопа и мобильных
                    </p>
                  </div>
                  <div className="flex gap-2" data-id="element-11193">
                    <Button variant="outline" size="sm" icon={<Monitor className="w-4 h-4" data-id="element-11195" />} data-id="element-11194">
                      Desktop
                    </Button>
                    <Button variant="outline" size="sm" icon={<Smartphone className="w-4 h-4" data-id="element-11197" />} data-id="element-11196">
                      Mobile
                    </Button>
                  </div>
                </div>

                <div className="flex-1 bg-slate-200 rounded-xl border border-slate-300 overflow-hidden flex items-center justify-center min-h-[400px] relative" data-id="element-11198">
                  <div className="w-[600px] h-[80%] bg-white shadow-xl rounded overflow-hidden flex flex-col" data-id="element-11199">
                    <div className="bg-slate-100 p-3 border-b border-slate-200 text-sm" data-id="element-11200">
                      <div data-id="element-11201">
                        <span className="text-slate-500 w-16 inline-block" data-id="element-11202">
                          From:
                        </span>{' '}
                        {c.senderIdentity}
                      </div>
                      <div data-id="element-11203">
                        <span className="text-slate-500 w-16 inline-block" data-id="element-11204">
                          Subject:
                        </span>{' '}
                        {c.subject}
                      </div>
                    </div>
                    <div className="flex-1 p-8 overflow-y-auto" data-id="element-11205">
                      <div className="max-w-md mx-auto text-center space-y-6" data-id="element-11206">
                        <div className="w-16 h-16 bg-indigo-100 rounded-full mx-auto flex items-center justify-center text-indigo-600 font-bold text-2xl" data-id="element-11207">
                          A
                        </div>
                        <h1 className="text-2xl font-bold text-slate-900" data-id="element-11208">
                          Здравствуйте, {'{{user.name}}'}!
                        </h1>
                        <p className="text-slate-600" data-id="element-11209">{c.previewText}</p>
                        <div className="w-full h-32 bg-slate-100 rounded-lg flex items-center justify-center text-slate-400" data-id="element-11210">
                          [Dynamic Content Block]
                        </div>
                        <Button variant="primary" size="lg" className="w-full" data-id="element-11211">
                          Call to Action
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}

            {detailTab === 'conversions' && <div className="space-y-6" data-id="element-11212">
                <Card padding="none" className="shadow-none border-slate-200 overflow-hidden" data-id="element-11213">
                  <div className="p-4 border-b border-slate-200 bg-white flex justify-between items-center" data-id="element-11214">
                    <h3 className="text-sm font-bold text-slate-900" data-id="element-11215">
                      Атрибуция конверсий (Last Click, 7 days)
                    </h3>
                    <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-11217" />} data-id="element-11216">
                      Экспорт CSV
                    </Button>
                  </div>
                  <table className="w-full text-left whitespace-nowrap" data-id="element-11218">
                    <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-11219">
                      <tr data-id="element-11220">
                        <th className="px-4 py-3 font-medium" data-id="element-11221">Order ID</th>
                        <th className="px-4 py-3 font-medium" data-id="element-11222">User ID</th>
                        <th className="px-4 py-3 font-medium" data-id="element-11223">Дата/Время</th>
                        <th className="px-4 py-3 font-medium" data-id="element-11224">Услуга</th>
                        <th className="px-4 py-3 font-medium text-right" data-id="element-11225">
                          Доход
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-11226">
                      {[1, 2, 3, 4, 5].map(i => <tr key={i} className="hover:bg-slate-50" data-id="element-11227">
                          <td className="px-4 py-3 text-sm font-mono text-indigo-600 cursor-pointer hover:underline" data-id="element-11228">
                            ORD-2026-{8000 + i}
                          </td>
                          <td className="px-4 py-3 text-sm font-mono text-slate-600" data-id="element-11229">
                            USR-{1000 + i * 7}
                          </td>
                          <td className="px-4 py-3 text-xs text-slate-500" data-id="element-11230">
                            16.03.2026 14:{10 + i}
                          </td>
                          <td className="px-4 py-3 text-sm text-slate-900" data-id="element-11231">
                            Натальная карта Premium
                          </td>
                          <td className="px-4 py-3 text-sm font-bold text-emerald-600 text-right" data-id="element-11232">
                            3 900 ₽
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  <div className="p-4 border-t border-slate-100 bg-slate-50 text-center text-sm text-slate-500" data-id="element-11233">
                    Показано 5 из {c.conversions} конверсий
                  </div>
                </Card>
              </div>}

            {detailTab === 'payment' && <div className="space-y-6" data-id="element-11234">
                <Card padding="md" className="shadow-none border-slate-200 max-w-2xl mx-auto" data-id="element-11235">
                  <div className="flex items-center justify-between mb-6" data-id="element-11236">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-11237">
                      Статус оплаты размещения
                    </h3>
                    <Badge variant={c.paymentStatus === 'paid' ? 'success' : c.paymentStatus === 'n/a' ? 'neutral' : 'warning'} data-id="element-11238">
                      {c.paymentStatus === 'paid' ? 'Оплачено' : c.paymentStatus === 'n/a' ? 'Не требуется' : 'Ожидает оплаты'}
                    </Badge>
                  </div>

                  {c.paymentStatus === 'paid' ? <div className="space-y-4" data-id="element-11239">
                      <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-4 flex items-start gap-3" data-id="element-11240">
                        <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5" data-id="element-11241" />
                        <div data-id="element-11242">
                          <div className="font-bold text-emerald-800" data-id="element-11243">
                            Оплата получена
                          </div>
                          <div className="text-sm text-emerald-600 mt-1" data-id="element-11244">
                            Кампания допущена к отправке
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-slate-100" data-id="element-11245">
                        <div data-id="element-11246">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-11247">
                            Рекламодатель
                          </div>
                          <div className="text-sm font-medium text-slate-900" data-id="element-11248">
                            {c.advertiser}
                          </div>
                        </div>
                        <div data-id="element-11249">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-11250">
                            Сумма
                          </div>
                          <div className="text-sm font-bold text-slate-900" data-id="element-11251">
                            40 000 ₽
                          </div>
                        </div>
                        <div data-id="element-11252">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-11253">
                            Invoice ID
                          </div>
                          <div className="text-sm font-mono text-indigo-600 cursor-pointer hover:underline" data-id="element-11254">
                            INV-2026-03-15
                          </div>
                        </div>
                        <div data-id="element-11255">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-11256">
                            Payment ID
                          </div>
                          <div className="text-sm font-mono text-slate-600" data-id="element-11257">
                            ch_1Oxyz2e...
                          </div>
                        </div>
                      </div>
                      <Button variant="outline" className="w-full mt-4" icon={<FileText className="w-4 h-4" data-id="element-11259" />} data-id="element-11258">
                        Скачать чек
                      </Button>
                    </div> : <div className="text-center py-8 text-slate-500" data-id="element-11260">
                      Для системных и внутренних кампаний оплата не требуется.
                    </div>}
                </Card>
              </div>}

            {detailTab === 'timeline' && <div className="space-y-6 max-w-2xl mx-auto" data-id="element-11261">
                <div className="relative border-l-2 border-slate-200 ml-4 space-y-8 pb-8" data-id="element-11262">
                  <div className="relative pl-6" data-id="element-11263">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-emerald-500 border-4 border-slate-50" data-id="element-11264" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11265">
                      15.03.2026 10:45
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-11266">
                      Отправка завершена
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-11267">
                      Успешно отправлено 45,000 писем.
                    </div>
                  </div>
                  <div className="relative pl-6" data-id="element-11268">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-blue-500 border-4 border-slate-50" data-id="element-11269" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11270">
                      15.03.2026 10:00
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-11271">
                      Отправка начата
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-11272">
                      Кампания передана провайдеру SendGrid.
                    </div>
                  </div>
                  <div className="relative pl-6" data-id="element-11273">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-amber-500 border-4 border-slate-50" data-id="element-11274" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11275">
                      14.03.2026 18:30
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-11276">
                      Поставлено в расписание (Scheduled)
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-11277">
                      Пользователь admin@astriqo.com запланировал отправку.
                    </div>
                  </div>
                  <div className="relative pl-6" data-id="element-11278">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-4 border-slate-50" data-id="element-11279" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11280">
                      14.03.2026 15:20
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-11281">
                      Кампания создана
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-11282">
                      Создан черновик.
                    </div>
                  </div>
                </div>
              </div>}

            {detailTab === 'logs' && <div className="space-y-4" data-id="element-11283">
                <div className="flex justify-between items-center bg-slate-900 text-white p-4 rounded-t-xl" data-id="element-11284">
                  <div className="flex items-center gap-2" data-id="element-11285">
                    <TerminalSquare className="w-5 h-5 text-slate-400" data-id="element-11286" />
                    <span className="font-mono text-sm" data-id="element-11287">
                      Provider Logs: {c.provider}
                    </span>
                  </div>
                  <Button variant="outline" size="sm" className="border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white" data-id="element-11288">
                    Download Logs
                  </Button>
                </div>
                <div className="bg-slate-950 text-emerald-400 p-4 rounded-b-xl font-mono text-xs overflow-x-auto h-[400px] overflow-y-auto space-y-2" data-id="element-11289">
                  <div data-id="element-11290">
                    [2026-03-15 10:00:01] INFO: Initiating batch send for
                    EC-2026-001 (45000 recipients)
                  </div>
                  <div data-id="element-11291">
                    [2026-03-15 10:00:05] INFO: Batch 1/45 dispatched to
                    SendGrid API (Status: 202 Accepted)
                  </div>
                  <div data-id="element-11292">
                    [2026-03-15 10:00:12] INFO: Batch 2/45 dispatched to
                    SendGrid API (Status: 202 Accepted)
                  </div>
                  <div className="text-rose-400" data-id="element-11293">
                    [2026-03-15 10:00:18] WARN: Rate limit approaching.
                    Throttling requests.
                  </div>
                  <div data-id="element-11294">
                    [2026-03-15 10:00:25] INFO: Batch 3/45 dispatched to
                    SendGrid API (Status: 202 Accepted)
                  </div>
                  <div className="text-slate-500" data-id="element-11295">
                    ... 40 similar log entries ...
                  </div>
                  <div data-id="element-11296">[2026-03-15 10:45:12] INFO: Final batch dispatched.</div>
                  <div data-id="element-11297">
                    [2026-03-15 10:45:15] INFO: Campaign EC-2026-001 processing
                    completed.
                  </div>
                  <div className="text-blue-400" data-id="element-11298">
                    [2026-03-15 10:46:00] WEBHOOK: Received 150 delivery events
                  </div>
                  <div className="text-blue-400" data-id="element-11299">
                    [2026-03-15 10:46:05] WEBHOOK: Received 45 open events
                  </div>
                  <div className="text-orange-400" data-id="element-11300">
                    [2026-03-15 10:46:10] WEBHOOK: Received 2 bounce events
                    (Hard bounce)
                  </div>
                </div>
              </div>}

            {detailTab === 'abtest' && <div className="space-y-6 max-w-3xl mx-auto text-center py-12" data-id="element-11301">
                {c.abTestId ? <div data-id="element-11302">
                    <SplitSquareHorizontal className="w-16 h-16 text-indigo-200 mx-auto mb-4" data-id="element-11303" />
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-11304">
                      A/B Тест активен
                    </h3>
                    <p className="text-slate-500 mb-6" data-id="element-11305">
                      Эта кампания участвует в сплит-тестировании {c.abTestId}.
                    </p>
                    <Button variant="primary" onClick={() => {
                setActiveCampaignDetail(null);
                setActiveTab('abtests');
              }} data-id="element-11306">
                      Перейти к результатам теста
                    </Button>
                  </div> : <div data-id="element-11307">
                    <SplitSquareHorizontal className="w-16 h-16 text-slate-200 mx-auto mb-4" data-id="element-11308" />
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-11309">
                      Нет активных A/B тестов
                    </h3>
                    <p className="text-slate-500 mb-6" data-id="element-11310">
                      Для этой кампании не настроено сплит-тестирование.
                    </p>
                    <Button variant="outline" data-id="element-11311">Настроить A/B тест</Button>
                  </div>}
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- CREATE MODAL ---
  const renderCreateModal = () => {
    if (!showCreateModal) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-11312">
        <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-11313">
          <div className="flex justify-between items-center mb-6" data-id="element-11314">
            <div data-id="element-11315">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-11316">
                {editingCampaign ? 'Редактирование кампании' : 'Новая email-кампания'}
              </h3>
              <p className="text-sm text-slate-500" data-id="element-11317">
                Создание и настройка рассылки
              </p>
            </div>
            <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-11319" />} onClick={() => setShowCreateModal(false)} data-id="element-11318" />
          </div>

          <div className="space-y-6" data-id="element-11320">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-11321">
              <div data-id="element-11322">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11323">
                  Название кампании (внутреннее)
                </label>
                <input type="text" placeholder="Например: Промо Соляр Май" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.name} onChange={e => setCreateForm({
                ...createForm,
                name: e.target.value
              })} data-id="element-11324" />
              </div>
              <div data-id="element-11325">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11326">
                  Тип кампании
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.type} onChange={e => setCreateForm({
                ...createForm,
                type: e.target.value
              })} data-id="element-11327">
                  <option value="promotional" data-id="element-11328">Промо (Promotional)</option>
                  <option value="digest" data-id="element-11329">Дайджест (Newsletter)</option>
                  <option value="paid_placement" data-id="element-11330">
                    Платное размещение (Paid)
                  </option>
                  <option value="system" data-id="element-11331">Системное (System)</option>
                </select>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4" data-id="element-11332">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-11333">
                Контент письма
              </h4>
              <div className="space-y-4" data-id="element-11334">
                <div data-id="element-11335">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11336">
                    Тема письма (Subject)
                  </label>
                  <input type="text" placeholder="Привлекательный заголовок..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.subject} onChange={e => setCreateForm({
                  ...createForm,
                  subject: e.target.value
                })} data-id="element-11337" />
                </div>
                <div data-id="element-11338">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11339">
                    Превью текст (Preheader)
                  </label>
                  <input type="text" placeholder="Текст, который виден в списке писем..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.previewText} onChange={e => setCreateForm({
                  ...createForm,
                  previewText: e.target.value
                })} data-id="element-11340" />
                </div>
                <div data-id="element-11341">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11342">
                    Шаблон (Template ID)
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.templateId} onChange={e => setCreateForm({
                  ...createForm,
                  templateId: e.target.value
                })} data-id="element-11343">
                    <option value="TPL-001" data-id="element-11344">TPL-001: Стандартный промо</option>
                    <option value="TPL-002" data-id="element-11345">
                      TPL-002: Ежемесячный дайджест
                    </option>
                    <option value="TPL-005" data-id="element-11346">TPL-005: Скидка / Акция</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4" data-id="element-11347">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-11348">
                Аудитория и отправка
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-11349">
                <div data-id="element-11350">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11351">
                    Сегмент получателей
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.segment} onChange={e => setCreateForm({
                  ...createForm,
                  segment: e.target.value
                })} data-id="element-11352">
                    <option value="Все активные пользователи (~45k)" data-id="element-11353">
                      Все активные пользователи (~45k)
                    </option>
                    <option value="VIP клиенты (~1.2k)" data-id="element-11354">
                      VIP клиенты (~1.2k)
                    </option>
                    <option value="Пользователи без заказа (~12k)" data-id="element-11355">
                      Пользователи без заказа (~12k)
                    </option>
                  </select>
                </div>
                <div data-id="element-11356">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11357">
                    Дата и время отправки
                  </label>
                  <input type="datetime-local" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.sendDate} onChange={e => setCreateForm({
                  ...createForm,
                  sendDate: e.target.value
                })} data-id="element-11358" />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center mt-8 pt-4 border-t border-slate-100" data-id="element-11359">
            <Button variant="outline" icon={<SplitSquareHorizontal className="w-4 h-4" data-id="element-11361" />} data-id="element-11360">
              Добавить A/B тест
            </Button>
            <div className="flex gap-3" data-id="element-11362">
              <Button variant="outline" onClick={() => setShowCreateModal(false)} data-id="element-11363">
                Отмена
              </Button>
              <Button variant="primary" onClick={() => {
              if (!createForm.name || !createForm.subject) {
                success('Заполните обязательные поля');
                return;
              }
              if (editingCampaign) {
                setCampaigns(campaigns.map(c => c.id === editingCampaign.id ? {
                  ...c,
                  ...createForm,
                  date: createForm.sendDate || c.date
                } : c));
                success('Кампания обновлена');
              } else {
                const newCampaign = {
                  id: `EC-2026-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
                  name: createForm.name,
                  type: createForm.type,
                  advertiser: 'Astriqo',
                  segment: createForm.segment,
                  audienceSize: createForm.segment.includes('45k') ? 45000 : createForm.segment.includes('1.2k') ? 1200 : 12000,
                  date: createForm.sendDate ? new Date(createForm.sendDate).toLocaleString('ru-RU') : 'Не задано',
                  status: 'draft',
                  sent: 0,
                  delivered: 0,
                  opens: 0,
                  openRate: '0%',
                  clicks: 0,
                  ctr: '0%',
                  conversions: 0,
                  conversionRate: '0%',
                  revenue: 0,
                  rpm: 0,
                  bounce: 0,
                  bounceRate: '0%',
                  unsubscribe: 0,
                  unsubscribeRate: '0%',
                  spam: 0,
                  paymentStatus: 'n/a',
                  templateId: createForm.templateId,
                  subject: createForm.subject,
                  previewText: createForm.previewText,
                  abTestId: null,
                  automationId: null,
                  provider: 'SendGrid',
                  senderIdentity: 'news@astriqo.com'
                };
                setCampaigns([newCampaign, ...campaigns]);
                success('Кампания сохранена как черновик');
              }
              setShowCreateModal(false);
            }} data-id="element-11364">
                {editingCampaign ? 'Сохранить изменения' : 'Сохранить черновик'}
              </Button>
            </div>
          </div>
        </Card>
      </div>;
  };
  // --- TEMPLATE DETAIL MODAL ---
  const renderTemplateDetailModal = () => {
    if (!activeTemplateDetail) return null;
    const t = activeTemplateDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-11365">
        <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-11366">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-11367">
            <div className="flex items-start gap-4" data-id="element-11368">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0" data-id="element-11369">
                <LayoutList className="w-6 h-6" data-id="element-11370" />
              </div>
              <div data-id="element-11371">
                <div className="flex items-center gap-3 mb-1" data-id="element-11372">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-11373">
                    {templateEditMode ? t.id === 'NEW' ? 'Создание шаблона' : 'Редактирование шаблона' : t.name}
                  </h2>
                  {!templateEditMode && <Badge variant={t.status === 'active' ? 'success' : 'neutral'} data-id="element-11374">
                      {t.status}
                    </Badge>}
                </div>
                {!templateEditMode && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-11375">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-11376">
                      {t.id}
                    </span>
                    <span data-id="element-11377">v{t.version}</span>
                    <span data-id="element-11378">{t.updatedAt}</span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-11379">
              {!templateEditMode && <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-11381" />} onClick={() => {
              setTemplateForm({
                name: t.name,
                type: t.type,
                subject: t.subject,
                previewText: t.previewText
              });
              setTemplateEditMode(true);
            }} data-id="element-11380">
                  Редактировать
                </Button>}
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-11383" />} onClick={() => setActiveTemplateDetail(null)} data-id="element-11382" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-11384">
            {templateEditMode ? <div className="space-y-6 max-w-2xl mx-auto" data-id="element-11385">
                <div data-id="element-11386">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11387">
                    Название шаблона
                  </label>
                  <input type="text" value={templateForm.name} onChange={e => setTemplateForm({
                ...templateForm,
                name: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11388" />
                </div>
                <div data-id="element-11389">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11390">
                    Тип
                  </label>
                  <select value={templateForm.type} onChange={e => setTemplateForm({
                ...templateForm,
                type: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11391">
                    <option value="promo" data-id="element-11392">Промо</option>
                    <option value="newsletter" data-id="element-11393">Дайджест</option>
                    <option value="transactional" data-id="element-11394">Транзакционное</option>
                  </select>
                </div>
                <div data-id="element-11395">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11396">
                    Тема по умолчанию
                  </label>
                  <input type="text" value={templateForm.subject} onChange={e => setTemplateForm({
                ...templateForm,
                subject: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11397" />
                </div>
                <div data-id="element-11398">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11399">
                    Превью текст
                  </label>
                  <input type="text" value={templateForm.previewText} onChange={e => setTemplateForm({
                ...templateForm,
                previewText: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11400" />
                </div>
                <div className="pt-4 border-t border-slate-200 flex justify-end gap-3" data-id="element-11401">
                  <Button variant="outline" onClick={() => {
                if (t.id === 'NEW') setActiveTemplateDetail(null);else setTemplateEditMode(false);
              }} data-id="element-11402">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('Шаблон сохранен');
                setActiveTemplateDetail(null);
              }} data-id="element-11403">
                    Сохранить
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-11404">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-11405">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11406">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-11407">
                      Информация
                    </h3>
                    <div className="space-y-3" data-id="element-11408">
                      <div className="flex justify-between" data-id="element-11409">
                        <span className="text-xs text-slate-500" data-id="element-11410">Тип</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11411">
                          {t.type}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11412">
                        <span className="text-xs text-slate-500" data-id="element-11413">Тема</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11414">
                          {t.subject}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-11415">
                        <span className="text-xs text-slate-500" data-id="element-11416">Превью</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-11417">
                          {t.previewText}
                        </span>
                      </div>
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 flex flex-col items-center justify-center text-center" data-id="element-11418">
                    <Monitor className="w-12 h-12 text-slate-300 mb-4" data-id="element-11419" />
                    <p className="text-sm text-slate-500 mb-4" data-id="element-11420">
                      HTML редактор доступен в полной версии
                    </p>
                    <Button variant="outline" icon={<Code className="w-4 h-4" data-id="element-11422" />} data-id="element-11421">
                      Открыть в редакторе
                    </Button>
                  </Card>
                </div>
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- SEGMENT DETAIL MODAL ---
  const renderSegmentDetailModal = () => {
    if (!activeSegmentDetail) return null;
    const s = activeSegmentDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-11423">
        <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-11424">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-11425">
            <div className="flex items-start gap-4" data-id="element-11426">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 shrink-0" data-id="element-11427">
                <Users className="w-6 h-6" data-id="element-11428" />
              </div>
              <div data-id="element-11429">
                <div className="flex items-center gap-3 mb-1" data-id="element-11430">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-11431">
                    {segmentEditMode ? s.id === 'NEW' ? 'Создание сегмента' : 'Редактирование сегмента' : s.name}
                  </h2>
                  {!segmentEditMode && <Badge variant={s.type === 'dynamic' ? 'pro' : 'neutral'} data-id="element-11432">
                      {s.type}
                    </Badge>}
                </div>
                {!segmentEditMode && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-11433">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-11434">
                      {s.id}
                    </span>
                    <span data-id="element-11435">{s.updatedAt}</span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-11436">
              {!segmentEditMode && <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-11438" />} onClick={() => {
              setSegmentForm({
                name: s.name,
                type: s.type,
                rules: s.rules
              });
              setSegmentEditMode(true);
            }} data-id="element-11437">
                  Редактировать
                </Button>}
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-11440" />} onClick={() => setActiveSegmentDetail(null)} data-id="element-11439" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-11441">
            {segmentEditMode ? <div className="space-y-6 max-w-2xl mx-auto" data-id="element-11442">
                <div data-id="element-11443">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11444">
                    Название сегмента
                  </label>
                  <input type="text" value={segmentForm.name} onChange={e => setSegmentForm({
                ...segmentForm,
                name: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11445" />
                </div>
                <div data-id="element-11446">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11447">
                    Тип сегмента
                  </label>
                  <select value={segmentForm.type} onChange={e => setSegmentForm({
                ...segmentForm,
                type: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11448">
                    <option value="dynamic" data-id="element-11449">
                      Динамический (обновляется автоматически)
                    </option>
                    <option value="static" data-id="element-11450">
                      Статический (фиксированный список)
                    </option>
                  </select>
                </div>
                <div data-id="element-11451">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11452">
                    Правила (SQL / JSON)
                  </label>
                  <textarea value={segmentForm.rules} onChange={e => setSegmentForm({
                ...segmentForm,
                rules: e.target.value
              })} rows={6} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm font-mono focus:outline-none focus:border-indigo-500" placeholder="last_login < 30 days..." data-id="element-11453" />
                </div>
                <div className="pt-4 border-t border-slate-200 flex justify-end gap-3" data-id="element-11454">
                  <Button variant="outline" onClick={() => {
                if (s.id === 'NEW') setActiveSegmentDetail(null);else setSegmentEditMode(false);
              }} data-id="element-11455">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('Сегмент сохранен');
                setActiveSegmentDetail(null);
              }} data-id="element-11456">
                    Сохранить
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-11457">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11458">
                  <Card padding="md" className="shadow-none border-slate-200 md:col-span-1 flex flex-col items-center justify-center text-center" data-id="element-11459">
                    <div className="text-sm text-slate-500 mb-2" data-id="element-11460">
                      Размер аудитории
                    </div>
                    <div className="text-4xl font-bold text-slate-900 mb-2" data-id="element-11461">
                      {s.size.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-xs text-slate-400" data-id="element-11462">пользователей</div>
                    <Button variant="outline" size="sm" className="mt-4 w-full" data-id="element-11463">
                      Экспорт списка
                    </Button>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 md:col-span-2" data-id="element-11464">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-11465">
                      Правила сегментации
                    </h3>
                    <div className="bg-slate-100 rounded-lg p-4" data-id="element-11466">
                      <code className="text-sm text-slate-800 block whitespace-pre-wrap" data-id="element-11467">
                        {s.rules}
                      </code>
                    </div>
                  </Card>
                </div>
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- AUTOMATION DETAIL MODAL ---
  const renderAutomationDetailModal = () => {
    if (!activeAutomationDetail) return null;
    const a = activeAutomationDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-11468">
        <Card className="w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-11469">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-11470">
            <div className="flex items-start gap-4" data-id="element-11471">
              <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600 shrink-0" data-id="element-11472">
                <Zap className="w-6 h-6" data-id="element-11473" />
              </div>
              <div data-id="element-11474">
                <div className="flex items-center gap-3 mb-1" data-id="element-11475">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-11476">
                    {automationEditMode ? a.id === 'NEW' ? 'Создание автоматизации' : 'Редактирование автоматизации' : a.name}
                  </h2>
                  {!automationEditMode && <Badge variant={a.status === 'active' ? 'success' : 'neutral'} data-id="element-11477">
                      {a.status}
                    </Badge>}
                </div>
                {!automationEditMode && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-11478">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-11479">
                      {a.id}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-11480">
                      <Target className="w-3.5 h-3.5" data-id="element-11481" /> {a.trigger}
                    </span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-11482">
              {!automationEditMode && <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-11484" />} onClick={() => setAutomationEditMode(true)} data-id="element-11483">
                  Редактировать
                </Button>}
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-11486" />} onClick={() => setActiveAutomationDetail(null)} data-id="element-11485" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-11487">
            {automationEditMode ? <div className="flex flex-col items-center justify-center h-full text-center py-12" data-id="element-11488">
                <Layers className="w-16 h-16 text-slate-300 mb-4" data-id="element-11489" />
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-11490">
                  Визуальный редактор автоматизаций
                </h3>
                <p className="text-slate-500 mb-6 max-w-md mx-auto" data-id="element-11491">
                  Конструктор цепочек писем (Flow Builder) доступен в
                  расширенной версии платформы.
                </p>
                <div className="flex gap-3" data-id="element-11492">
                  <Button variant="outline" onClick={() => {
                if (a.id === 'NEW') setActiveAutomationDetail(null);else setAutomationEditMode(false);
              }} data-id="element-11493">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('Изменения сохранены');
                setActiveAutomationDetail(null);
              }} data-id="element-11494">
                    Сохранить
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-11495">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-11496">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11497">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11498">
                      Шагов в цепочке
                    </div>
                    <div className="text-2xl font-bold text-slate-900" data-id="element-11499">
                      {a.steps}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11500">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11501">
                      Активных подписчиков
                    </div>
                    <div className="text-2xl font-bold text-blue-600" data-id="element-11502">
                      {a.activeSubscribers.toLocaleString('ru-RU')}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11503">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-11504">
                      Завершили цепочку
                    </div>
                    <div className="text-2xl font-bold text-emerald-600" data-id="element-11505">
                      {a.completed.toLocaleString('ru-RU')}
                    </div>
                  </Card>
                </div>

                <Card padding="md" className="shadow-none border-slate-200" data-id="element-11506">
                  <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-11507">
                    Схема цепочки
                  </h3>
                  <div className="space-y-4 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-300 before:to-transparent" data-id="element-11508">
                    <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-11509">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-amber-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-11510">
                        <Target className="w-4 h-4" data-id="element-11511" />
                      </div>
                      <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-11512">
                        <div className="font-bold text-slate-900 mb-1" data-id="element-11513">
                          Триггер
                        </div>
                        <div className="text-sm text-slate-500" data-id="element-11514">
                          {a.trigger}
                        </div>
                      </div>
                    </div>

                    <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-11515">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-indigo-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-11516">
                        <Mail className="w-4 h-4" data-id="element-11517" />
                      </div>
                      <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-11518">
                        <div className="flex justify-between items-start mb-1" data-id="element-11519">
                          <div className="font-bold text-slate-900" data-id="element-11520">
                            Email #1
                          </div>
                          <Badge variant="success" size="sm" data-id="element-11521">
                            Отправлено: 12.4k
                          </Badge>
                        </div>
                        <div className="text-sm text-slate-500" data-id="element-11522">
                          Отправляется сразу после триггера
                        </div>
                      </div>
                    </div>

                    {a.steps > 1 && <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-11523">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-slate-400 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-11524">
                          <Clock className="w-4 h-4" data-id="element-11525" />
                        </div>
                        <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-11526">
                          <div className="font-bold text-slate-900 mb-1" data-id="element-11527">
                            Задержка
                          </div>
                          <div className="text-sm text-slate-500" data-id="element-11528">
                            Ожидание 2 дня
                          </div>
                        </div>
                      </div>}
                  </div>
                </Card>
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- AB TEST DETAIL MODAL ---
  const renderAbTestDetailModal = () => {
    if (!activeAbTestDetail) return null;
    const t = activeAbTestDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-11529">
        <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-11530">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-11531">
            <div className="flex items-start gap-4" data-id="element-11532">
              <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center text-rose-600 shrink-0" data-id="element-11533">
                <SplitSquareHorizontal className="w-6 h-6" data-id="element-11534" />
              </div>
              <div data-id="element-11535">
                <div className="flex items-center gap-3 mb-1" data-id="element-11536">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-11537">
                    {t.id === 'NEW' ? 'Новый A/B Тест' : t.name}
                  </h2>
                  {t.id !== 'NEW' && <Badge variant={t.status === 'completed' ? 'success' : 'warning'} data-id="element-11538">
                      {t.status}
                    </Badge>}
                </div>
                {t.id !== 'NEW' && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-11539">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-11540">
                      {t.id}
                    </span>
                    <span data-id="element-11541">Кампания: {t.campaignId}</span>
                    <span className="uppercase" data-id="element-11542">Тип: {t.type}</span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-11543">
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-11545" />} onClick={() => setActiveAbTestDetail(null)} data-id="element-11544" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-11546">
            {t.id === 'NEW' ? <div className="space-y-6 max-w-2xl mx-auto" data-id="element-11547">
                <div data-id="element-11548">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11549">
                    Название теста
                  </label>
                  <input type="text" placeholder="Например: Тест заголовков" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11550" />
                </div>
                <div data-id="element-11551">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11552">
                    Кампания
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11553">
                    <option data-id="element-11554">Выберите кампанию...</option>
                    {mockCampaigns.map(c => <option key={c.id} value={c.id} data-id="element-11555">
                        {c.name}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-11556">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11557">
                    Что тестируем?
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11558">
                    <option value="subject" data-id="element-11559">Тема письма (Subject)</option>
                    <option value="content" data-id="element-11560">Контент / Шаблон</option>
                    <option value="sender" data-id="element-11561">Имя отправителя</option>
                    <option value="time" data-id="element-11562">Время отправки</option>
                  </select>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-11563">
                  <div data-id="element-11564">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11565">
                      Вариант A (Контрольный)
                    </label>
                    <input type="text" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11566" />
                  </div>
                  <div data-id="element-11567">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11568">
                      Вариант B (Тестовый)
                    </label>
                    <input type="text" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-11569" />
                  </div>
                </div>
                <div className="pt-4 border-t border-slate-200 flex justify-end gap-3" data-id="element-11570">
                  <Button variant="outline" onClick={() => setActiveAbTestDetail(null)} data-id="element-11571">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('A/B Тест создан');
                setActiveAbTestDetail(null);
              }} data-id="element-11572">
                    Создать тест
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-11573">
                {t.winner && <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 p-4 rounded-xl flex items-center gap-3" data-id="element-11574">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-11575" />
                    <div data-id="element-11576">
                      <div className="font-bold" data-id="element-11577">
                        Тест завершен. Победитель: {t.winner}
                      </div>
                      <div className="text-sm text-emerald-600" data-id="element-11578">
                        Оставшаяся аудитория получит победивший вариант.
                      </div>
                    </div>
                  </div>}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-11579">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-11580">
                    <div className="flex justify-between items-center mb-4" data-id="element-11581">
                      <h3 className="text-sm font-bold text-slate-900" data-id="element-11582">
                        Вариант A
                      </h3>
                      <Badge variant="neutral" data-id="element-11583">
                        {t.split.split('/')[0]}% аудитории
                      </Badge>
                    </div>
                    <div className="bg-slate-100 p-3 rounded-lg mb-6" data-id="element-11584">
                      <div className="text-sm text-slate-700" data-id="element-11585">{t.variantA}</div>
                    </div>
                    <div className="space-y-4" data-id="element-11586">
                      <div data-id="element-11587">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-11588">
                          <span data-id="element-11589">Open Rate</span>
                          <span className="font-bold text-slate-900" data-id="element-11590">
                            32.4%
                          </span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-11591">
                          <div className="bg-blue-500 h-2 rounded-full" style={{
                        width: '32.4%'
                      }} data-id="element-11592"></div>
                        </div>
                      </div>
                      <div data-id="element-11593">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-11594">
                          <span data-id="element-11595">CTR</span>
                          <span className="font-bold text-slate-900" data-id="element-11596">4.1%</span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-11597">
                          <div className="bg-purple-500 h-2 rounded-full" style={{
                        width: '4.1%'
                      }} data-id="element-11598"></div>
                        </div>
                      </div>
                    </div>
                  </Card>

                  <Card padding="md" className="shadow-none border-slate-200 relative overflow-hidden" data-id="element-11599">
                    {t.winner?.includes('Variant B') && <div className="absolute top-0 right-0 bg-emerald-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg" data-id="element-11600">
                        ПОБЕДИТЕЛЬ
                      </div>}
                    <div className="flex justify-between items-center mb-4" data-id="element-11601">
                      <h3 className="text-sm font-bold text-slate-900" data-id="element-11602">
                        Вариант B
                      </h3>
                      <Badge variant="neutral" data-id="element-11603">
                        {t.split.split('/')[1]}% аудитории
                      </Badge>
                    </div>
                    <div className="bg-slate-100 p-3 rounded-lg mb-6" data-id="element-11604">
                      <div className="text-sm text-slate-700" data-id="element-11605">{t.variantB}</div>
                    </div>
                    <div className="space-y-4" data-id="element-11606">
                      <div data-id="element-11607">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-11608">
                          <span data-id="element-11609">Open Rate</span>
                          <span className="font-bold text-emerald-600" data-id="element-11610">
                            38.2%
                          </span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-11611">
                          <div className="bg-emerald-500 h-2 rounded-full" style={{
                        width: '38.2%'
                      }} data-id="element-11612"></div>
                        </div>
                      </div>
                      <div data-id="element-11613">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-11614">
                          <span data-id="element-11615">CTR</span>
                          <span className="font-bold text-emerald-600" data-id="element-11616">
                            5.8%
                          </span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-11617">
                          <div className="bg-emerald-500 h-2 rounded-full" style={{
                        width: '5.8%'
                      }} data-id="element-11618"></div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>}
          </div>
        </Card>
      </div>;
  };
  return <div className="space-y-6" data-id="element-11619">
      {/* Top Navigation Tabs */}
      <Tabs activeTab={activeTab} onChange={setActiveTab} tabs={[{
      id: 'campaigns',
      label: 'Кампании'
    }, {
      id: 'templates',
      label: 'Шаблоны'
    }, {
      id: 'audiences',
      label: 'Аудитории'
    }, {
      id: 'automations',
      label: 'Автоматизации'
    }, {
      id: 'abtests',
      label: 'A/B Тесты'
    }]} data-id="element-11620" />

      {/* Main Content Area */}
      <div data-id="element-11621">
        {activeTab === 'campaigns' && <>
            {renderTopMetrics()}
            {renderCampaignsTable()}
          </>}
        {activeTab === 'templates' && renderTemplates()}
        {activeTab === 'audiences' && renderAudiences()}
        {activeTab === 'automations' && renderAutomations()}
        {activeTab === 'abtests' && renderAbTests()}
      </div>

      {/* Modals */}
      {renderCampaignDetailModal()}
      {renderCreateModal()}
      {renderTemplateDetailModal()}
      {renderSegmentDetailModal()}
      {renderAutomationDetailModal()}
      {renderAbTestDetailModal()}
    </div>;
}